import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { LiquidacionService } from 'app/services/liquidacion/liquidacion.service';
import { LoginService } from 'app/services/login/login.service';
import Swal from 'sweetalert2';
import { environment } from 'environments/environment';
@Component({
  selector: 'app-detalle-resumen',
  templateUrl: './detalle-resumen.component.html',
  styleUrls: ['./detalle-resumen.component.scss']
})
export class DetalleResumenComponent implements OnInit {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_Simulador=environment.LABEL_SIMULADOR;
  
  @Output() CerrarPopUP : EventEmitter<boolean> = new EventEmitter();

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  
  dataSource : any = [];
  dataDetalle2 : any = [];
  loading:boolean;
  dataliqui:any;
  dataDetalle:any  = [];
  displayedColumns: string[] = [
    "idLiquidacion",
    "Fecha",
    "Fecha_Pago_Real",
    "Adelanto_Importe",
    "Comision_Proveedor",
    "Comision_Adquirente",
    "Interes_Proveedor",
    "Interes_Adquirente",
    "Liquidacion_Proveedor",
    "Liquidacion_Adquirente"
  ];
  constructor(private liquidacionService:LiquidacionService, private loginService:LoginService, private router:Router) {
    this.dataliqui = this.liquidacionService.arrayLiquidacionResumen
    let split = this.dataliqui.idLiquidaciones.split(",").map(Number);
    this.dataDetalle2={"idLiquidaciones":split}
   }

  ngOnInit() {
    this.obtenerlistado();
    
  }

  MatCerrarPopUP(){
    this.CerrarPopUP.emit();
}

guardarResumen() {
  this.loading = true;
  Swal.fire({
    title: "Espere",
    text: "Guardando Información",
    type: "info",
    allowOutsideClick: false,
    heightAuto: false
  });
  Swal.showLoading();
  setTimeout(() => {  
    Swal.fire({
      title: "Felicidades",
      text: "Resumen de liquidacion registrado",
      type: "success",
      allowOutsideClick: false,
      heightAuto: false
    }).then((res) => {
      if (res.value == true) {
         this.CerrarPopUP.emit();
        this.loading = false;
        this.loginService.clickGuard = true;
        this.router.navigate(['/liquidacion/liquidaciones-resumen/listado']);
      }
    });
  }, 3000);         
}


obtenerlistado(){
  this.loading = true;
  this.liquidacionService.obtenerLiquidacionesPoriD(this.dataDetalle2).subscribe(
    res =>{
        this.dataDetalle = res;
        this.dataSource = new MatTableDataSource(this.dataDetalle);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.loading = false;  
    },err =>{
        Swal.fire({
            title: "¡Algo salió mal!",
            text:  err.error['error'],
            type: "warning",
            allowOutsideClick: true,
            heightAuto: false 
        });
        this.loading = false;
    }
  );
}

}
